import PubSub from "underpub-js";
import gsap from 'gsap';

var HeroComplex = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-HeroComplex',
		hasLoaded: false,
	};

	$.extend(true, this.options, options);

};

HeroComplex.prototype.init = function() {

	var self = this;

	self.$gridContainer = self.options.$el.find(`.grid-container`);
	self.$imageWrapperInner = self.options.$el.find(`.${self.options.baseClass}__imageWrapperInner`);
	self.$image = self.options.$el.find(`.${self.options.baseClass}__image`);

	//$(window).on('load', () => self.animateIn());
	//setTimeout(() => !self.options.hasLoaded && $(window).trigger('load'), 2000);

	PubSub.subscribe('Sitewide:loaderOutComplete', function() {
		self.animateIn();
	});

};

HeroComplex.prototype.animateIn = function() {

	var self = this;

	self.options.hasLoaded = true;

	let position = self.$imageWrapperInner.position();

	let parentWidth = self.options.$el.outerWidth();
	let parentHeight = self.options.$el.outerHeight();

	let imageLeft = position.left;
	let imageRight = parentWidth - (position.left + self.$imageWrapperInner.outerWidth());
	let imageTop = position.top;
	let imageBottom = parentHeight - (position.top + self.$imageWrapperInner.outerHeight());

	self.animateInTimeline = gsap
		.timeline({
			delay: 1,
		})
		.call(
			() => { PubSub.publish('Header:fadeOutSecondaryLogo'); }
		)
		.to(self.$image, {
			duration: 1.5,
			ease: "power3.out",
			top: imageTop,
			bottom: imageBottom,
			left: imageLeft,
			right: imageRight,
		})
		.set(self.$gridContainer, {
			position: "relative"
		})
		.set(self.$imageWrapperInner, {
			position: "relative"
		})
		.set(self.$image, {
			clearProps: "all"
		})
		.call(
			() => { PubSub.publish('Header:updateHamburgerZIndex'); }
		)

};

export default HeroComplex;
